import { render, staticRenderFns } from "./giftRouter.vue?vue&type=template&id=4c88fe0e&scoped=true"
import script from "./giftRouter.vue?vue&type=script&lang=js"
export * from "./giftRouter.vue?vue&type=script&lang=js"
import style0 from "./giftRouter.vue?vue&type=style&index=0&id=4c88fe0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c88fe0e",
  null
  
)

export default component.exports